import { render, staticRenderFns } from "./StepTwoBase.vue?vue&type=template&id=22340d0c&scoped=true&"
import script from "./StepTwoBase.vue?vue&type=script&lang=js&"
export * from "./StepTwoBase.vue?vue&type=script&lang=js&"
import style0 from "./StepTwoBase.vue?vue&type=style&index=0&id=22340d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22340d0c",
  null
  
)

export default component.exports